import React from 'react';
import { Clock, Trash2 } from 'lucide-react';
import { useHistory } from '@/hooks';
import { buildImageUrl } from '@/utils/image-url';
import styles from './mobile-history.module.css';

export const MobileHistory: React.FC = () => {
  const { history, clearHistory } = useHistory();

  if (history.length === 0) {
    return (
      <section className={styles.section}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            <Clock className={styles.icon} size={18} />
            最近玩过
          </h2>
        </div>
        <div className={styles.empty}>
          <div className={styles.emptyIcon}>🎮</div>
          <p className={styles.emptyText}>还没有玩过游戏哦</p>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          <Clock className={styles.icon} size={18} />
          最近玩过
        </h2>
        <button 
          className={styles.clearBtn}
          onClick={clearHistory}
        >
          <Trash2 size={14} />
          清空
        </button>
      </div>
      <div className={styles.grid}>
        {history.map((item) => (
          <a
            key={item.id}
            href={`/game/${item.id}`}
            className={styles.item}
          >
            <div className={styles.iconWrapper}>
              <img
                src={buildImageUrl(item.icon)}
                alt={item.title}
                className={styles.iconImg}
                loading="lazy"
                onError={(e) => {
                  (e.target as HTMLImageElement).src = '/fallback-icon.png';
                }}
              />
            </div>
            <span className={styles.name}>{item.title}</span>
          </a>
        ))}
      </div>
    </section>
  );
};

export default MobileHistory;
